export default "__VITE_ASSET__CHATFEhi__"